<template>
  <div class="page-wrapper">
    <div class="page layout-page">
      <div class="page-header">
        <header-tool />
        <header-nav />
      </div>
      <div class="page-content">
        <router-view />
      </div>
      <!-- 页脚 -->
      <footer-component class="footer-wrap" />
    </div>
  </div>
</template>

<script>
import HeaderTool from '@/components/LayoutComponent/HeaderTool'
import FooterComponent from '@/components/LayoutComponent/FooterComponent'
import HeaderNav from '@/components/LayoutComponent/HeaderNav'

export default {
  name: 'Layout',
  components: {
    FooterComponent,
    HeaderTool,
    HeaderNav
  }
}
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
}
.layout-page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
}

.page-header {
  width: 100%;
}

.page-content {
  flex-grow: 1;
  width: 1200px;
  display: flex;
  margin: 20px 0;
}

.footer-wrap {
  width: 100%;
}
</style>
